import { ReactElement } from "react";
import { Link } from "react-router-dom";

import { PATH_TO_HOME } from "constants/navigation";

import styles from "./page-header.module.css";

const PageHeader = ({
  showBackToHomeLink = false,
  largeTitle = false,
  title,
  description,
  subTitle,
}: {
  showBackToHomeLink?: boolean;
  largeTitle?: boolean;
  title: string;
  description?: string | ReactElement;
  subTitle?: ReactElement;
}): ReactElement => {
  return (
    <>
      <div className={styles.headerContent}>
        {showBackToHomeLink && (
          <Link to={PATH_TO_HOME}>Back to Identity & security settings</Link>
        )}

        <h1
          className={`${styles.title} ${
            largeTitle ? styles.largeTitle : ""
          }`.trim()}
        >
          {title}
        </h1>

        {subTitle && <div className={styles.subTitle}>{subTitle}</div>}

        {description && <div className={styles.description}>{description}</div>}
      </div>
    </>
  );
};

export default PageHeader;
